export default __webpack_public_path__ + "assets/png/a1ef0dc7e53bdf647694f86bbab41026.png";